import { SerializedError, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiUrGetRecycling } from '@lib/core/productAttributes/slices/urls';
import { TRecycling } from '@lib/core/productAttributes/types';
import { request } from '@lib/core/service/requests/request';

export interface IRecyclingState {
  data: TRecycling[];
  error: SerializedError;
  isLoading: boolean;
}

export const initialState: IRecyclingState = {
  data: [],
  error: null,
  isLoading: false,
};

export const actionGetRecycling = createAsyncThunk('productAttributes/recycling/get', async () =>
  request({ url: apiUrGetRecycling }),
);

const recyclingSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(actionGetRecycling.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(actionGetRecycling.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
    });
    builder.addCase(actionGetRecycling.rejected, (state, action) => {
      state.error = action.error;
      state.isLoading = false;
    });
  },
  initialState,
  name: 'recycling',
  reducers: {},
});

export default recyclingSlice.reducer;
